import { render, staticRenderFns } from "./ProjectTeamPanel.vue?vue&type=template&id=79745077&scoped=true&"
import script from "./ProjectTeamPanel.vue?vue&type=script&lang=js&"
export * from "./ProjectTeamPanel.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTeamPanel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProjectTeamPanel.vue?vue&type=style&index=1&id=79745077&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79745077",
  null
  
)

export default component.exports